module.exports = __webpack_public_path__ + "assets/img/eleven02.57c32ab6.png";